import { IonPage, IonContent } from '@ionic/react'
import styled from 'styled-components'
import { CustomSpacer, FooterButtons, StyleIonHeader, TextStyle } from '../../../components'

export const IsSignIn: React.FC = () => {
  return (
    <IonPage>
      <StyleIonHeader type={'MAIN'} title={'SIGN IN'} />
      <IonContent>
        <ContentsContainer>
          <CustomSpacer spacing={'80px'} />
          <img
            src={`img/icon/warning.svg`}
            alt={'icon'}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null
              currentTarget.src = '/img/thumbnail.svg'
            }}
          />
          <CustomSpacer spacing={'12px'} />
          <TextStyle type={'m_13'} color={'primary_light'}>
            로그인 후 이용해주세요
          </TextStyle>
        </ContentsContainer>
      </IonContent>
      <FooterButtons button={{ color: 'dark', text: '로그인', link: '/signIn' }} />
    </IonPage>
  )
}
const ContentsContainer = styled.div`
  text-align: center;
  img {
    width: 36px;
    aspect-ratio: 1/1;
  }
`
